import React from 'react'
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
    onlyBtn: {
        width: '100%',
        borderRadius: 0
    },
    btnSend: {
        width: '50%',
        borderRadius: 0
    }
}))

const Alert = ({ info }) => {
    const { open, onClose, title, content, onlyButton, btn1Txt, btn2Txt, btn1Func, btn2Func } = info
    const classes = useStyles()
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <DialogTitle>{title}</DialogTitle>
                <Typography>{content}</Typography>
            </DialogContent>
            <Box style={{ marginTop: '12px' }}>
                {!onlyButton &&
                    <Button onClick={btn2Func} className={classes.btnSend} variant='contained' color='disabled'>{btn2Txt}</Button>
                }
                <Button onClick={btn1Func} className={onlyButton ? classes.onlyBtn : classes.btnSend} variant='contained' color='primary'>{btn1Txt}</Button>
            </Box>
        </Dialog>
    )
}

export { Alert }